import * as THREE from "three";

const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
renderer.setClearColor(0xffffff, 0);

export default renderer;